import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import type {InfernoUIEvent} from 'inferno';

import {CustomComponent, Link} from '../../common/components';
import {Icon} from '../../common/components/Icon';
import {ToggleMenu} from '../../common/components/ToggleMenu';
import rootScope from '../../common/services/rootScope';
import {cleanMultiwordTag, document, localURL} from '../../common/util';
import emitter from '../../common/util/emitter';

import {subscribe} from '../../../replete';

const secondsInADay = 24 * 60 * 60;


class NotificationsListItem extends CustomComponent {
    @autobind
    handleClick(event: Event) {
        const localizeUrlPath = this.context.gtService.localizeUrlPath;

        const notification = this.props.notification;
        notification.pending = false;
        this.triggerUpdate();
        // Prevent sub links from incorrectly redirecting.
        const target = event.target as HTMLAnchorElement;
        if (!target.href && notification.url) {
            this.redirect(localizeUrlPath(localURL(notification.url)));
        }
    }
    render() {
        const notification = this.props.notification;
        let classes = 'item notification';
        if (notification.pending) {
            classes += ' pending';
        }
        const msg = notification.msg;
        let htmlMsg: any = msg;
        // FIXME: We'll need to change this is if we support translated
        // notifications.
        if (htmlMsg.slice(-9) === 'your GIF!' ||
            notification.type === 'keyboarduserfollow') {
            // link username
            const firstSpaceIdx = htmlMsg.indexOf(' ');
            const username = htmlMsg.substring(0, firstSpaceIdx);
            const remainder = htmlMsg.substring(firstSpaceIdx);
            htmlMsg = [
                <Link key="link" to={this.linkToProfile({username})}>{username}</Link>,
                remainder,
            ];
        } else {
            htmlMsg = [];
            const tagRegex = /#(\w+)/g;
            const tagLinks: Element[] = [];
            msg.replace(tagRegex, (match: string, tag: string) => {
                tag = cleanMultiwordTag(tag);
                tagLinks.push(<Link to={this.linkToSearch(tag)}>{tag}</Link>);
                return match;
            });
            msg.split(/#\w+/g).forEach(function(val: string, idx: number) {
                htmlMsg.push(val);
                if (tagLinks[idx]) {
                    htmlMsg.push(tagLinks[idx]);
                }
            });
        }
        let imgSrc = '';
        if (notification.image) {
            imgSrc = notification.image.url;
        } else if (notification.avatarurl) {
            imgSrc = notification.avatarurl;
        }
        return (<a
            onClick={this.handleClick}
            className={classes}>
            <img src={imgSrc} width="40" height="40"/>
            <span className="msg">{htmlMsg}</span>
            <span className="timestamp">{rootScope.humanize(notification.timestamp)}</span>
        </a>);
    }
}

class NotificationsList extends Component<jsx.Props, jsx.State> {
    @autobind
    handleScroll(e: InfernoUIEvent<HTMLDivElement>) {
        const target = e.target as HTMLDivElement;
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight) {
            this.context.store.call('api.notifications', [], 'more');
        }
    }
    divideNotifications(notifications: api.Notification[]) {
        const thisMorning = rootScope.tzOffset +
            Math.floor((Date.now() / 1000) / secondsInADay) * secondsInADay;
        const yesterdayMorning = thisMorning - secondsInADay;

        const todayNotifications = [];
        const yesterdayNotifications = [];
        const earlierNotifications = [];

        // Divide all notifications into categories.
        for (let i = 0; i < notifications.length; i++) {
            const notification = notifications[i];
            if (notification.timestamp > thisMorning) {
                todayNotifications.push(notification);
            } else if (notification.timestamp > yesterdayMorning) {
                yesterdayNotifications.push(notification);
            } else {
                earlierNotifications.push(notification);
            }
        }
        return [
            todayNotifications,
            yesterdayNotifications,
            earlierNotifications,
        ];
    }
    render() {
        const gettextSub = this.context.gtService.gettextSub;
        const localizeUrlPath = this.context.gtService.localizeUrlPath;
        const notifications = this.props.notifications;
        const [
            todayNotifications,
            yesterdayNotifications,
            earlierNotifications,
        ] = this.divideNotifications(notifications);

        let classes = 'notifications-list';
        console.log('this.props.notifications', notifications);
        if (notifications.length) {
            classes += ' has-notifications';
        } else {
            classes += ' no-notifications';
        }

        const todayNotificationsEls = [];
        let notification;
        for (notification of todayNotifications) {
            todayNotificationsEls.push(<NotificationsListItem
                notification={notification}
            />);
        }

        const yesterdayNotificationsEls = [];
        for (notification of yesterdayNotifications) {
            yesterdayNotificationsEls.push(<NotificationsListItem
                notification={notification}
            />);
        }

        const earlierNotificationsEls = [];
        for (notification of earlierNotifications) {
            earlierNotificationsEls.push(<NotificationsListItem
                notification={notification}
            />);
        }

        return (<div className={classes} onScroll={this.handleScroll}>
            { todayNotificationsEls.length > 0 && <>
                <h3 className="item">{gettextSub('Today')}</h3>
                {todayNotificationsEls}
            </> }
            { yesterdayNotificationsEls.length > 0 && <>
                <h3 className="item">{gettextSub('Yesterday')}</h3>
                {yesterdayNotificationsEls}
            </> }
            { earlierNotificationsEls.length > 0 && <>
                <h3 className="item">{gettextSub('Earlier')}</h3>
                {earlierNotificationsEls}
            </> }
            { notifications.length === 0 && <div className="item">
                <p>{gettextSub('Upload GIFs, and you’ll get notifications when people share or favorite them')}</p>
                <Link to={localizeUrlPath('/gif-maker?utm_source=empty-notifications&utm_medium=internal&utm_campaign=gif-maker-entrypoints')} className="button">
                    {gettextSub('Upload')}
                </Link>
            </div> }
        </div>);
    }
}


@subscribe({
    notificationsData: ['api.notifications'],
})
export class NotificationIcon extends CustomComponent {
    intervalRef?: ReturnType<typeof setInterval>;

    @autobind
    clearPendingNotificationsCount() {
        emitter.emit('clearPendingNotificationsCount');
    }
    @autobind
    refreshNotifications() {
        if (!document.hidden) {
            emitter.emit('refreshNotifications');
        }
    }
    componentDidMount() {
        this.intervalRef = setInterval(
            this.refreshNotifications, 10 * 60 * 1000);
        document.addEventListener('visibilitychange', this.refreshNotifications);
    }
    componentWillUnmount() {
        clearInterval(this.intervalRef);
        document.removeEventListener('visibilitychange', this.refreshNotifications);
    }
    render() {
        const gettextSub = this.context.gtService.gettextSub;
        const notificationsData = this.props.notificationsData;
        console.log('notificationsData', notificationsData);

        return (<ToggleMenu className="navbar-icon notifications" togglemenu={true} onClick={this.clearPendingNotificationsCount} menu={<div className="animated">
            <h2 className="item">{gettextSub('Notifications')}</h2>
            <NotificationsList notifications={notificationsData.notifications}/>
        </div>}>
            <Icon name="notification-icon"/>
            { notificationsData.pending > 0 && <div className="pending-notifications-count">{ notificationsData.pending }</div> }
        </ToggleMenu>);
    }
}
